/**
 * A calendar date in the viewer's time zone as `YYYY-MM-DD` — what a date
 * picker and an address hold, and what a file is named after. The instant's UTC
 * date is the wrong day east of UTC: a window starting at local midnight would
 * be named after the previous day.
 */
export function localDayKey(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}
